import { ActionType } from "../Type";
export const updateLocalData = (actionType: ActionType) => ({ type: actionType.type, payload: actionType.payload });
